import { useGetUserSites } from 'api/Users'
import { useUser } from 'hooks/UseUser'
import { useEffect, useId, useState } from 'react'

export const Vitally = () => {
  if (!import.meta.env.VITE_APP_VITALLY_API_KEY) {
    return null
  }

  return <VitallyInit />
}

const VitallyInit = () => {
  const id = useId()
  const [loaded, setLoaded] = useState(false)
  const { sub: userId, email, given_name: firstName, family_name: lastName } = useUser()
  const [currentSite, setCurrentSite] = useState(undefined)
  const storageSiteId = sessionStorage.getItem('activeSiteId')
  const { data: { data: sites = [] } = {} } = useGetUserSites(userId, {
    enabled: !!userId,
    cacheTime: Infinity,
    staleTime: 60 * 60 * 1000, // 60 minutes
  })

  /**
   * Load Vitally JS.
   */
  useEffect(() => {
    if (loaded || document.getElementById(id)) return

    const url = 'https://cdn.vitally-eu.io/vitally.js/v1/vitally.js'

    const s = document.createElement('script')
    s.id = id
    s.src = url
    s.addEventListener('load', () => setLoaded(true), { once: true })
    document.head.appendChild(s)
  }, [id, loaded])

  useEffect(() => {
    if (storageSiteId && sites.length > 0 && storageSiteId !== currentSite?.id) {
      const foundSite = sites.find((site) => site.id === storageSiteId)
      setCurrentSite(foundSite)
    }
  }, [storageSiteId, sites, currentSite?.id])

  /**
   * Initialise Vitally.
   */
  useEffect(() => {
    if (!loaded || !currentSite) {
      return
    }

    const vitally = window.Vitally

    vitally.init(import.meta.env.VITE_APP_VITALLY_API_KEY, 'https://api.vitally-eu.io/analytics/v1')

    vitally.organization({
      organizationId: currentSite.organisation_id,
      traits: {
        name: currentSite.organisation_name,
      },
    })

    vitally.account({
      accountId: currentSite.id,
      organizationId: currentSite.organisation_id,
      traits: {
        name: currentSite.name,
      },
    })

    vitally.user({
      userId: userId,
      accountId: currentSite.id,
      organizationId: currentSite.organisation_id,
      traits: {
        name: [firstName, lastName].filter(Boolean).join(' '),
        email: email,
      },
    })

    vitally.nps('survey', {
      productName: 'Trybe',
      delay: 5000, // 5000ms (5 second) delay if the user is suppose to be displayed the survey
    })
  }, [currentSite, email, firstName, lastName, loaded, userId])

  if (!loaded || !window.Vitally || !currentSite) {
    return null
  }

  return (
    <script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `!function(n,t,i){for(var o=n[t]=n[t]||[],r=function(i){o[i]=o[i]||function(){for(var n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];return o.push([i,n])}},a=0,u=["init","user","account","organization","track","nps"];a<u.length;a++){r(u[a])}}(window,"Vitally");`,
      }}
    />
  )
}
